import React from 'react';
import FreeTypeSelectInput from "../../../formElements/FreeTypeSelectInput";

function InstrumentSelector(props) {
    function getOptions() {
        let options = [];
        if (!props.data || !props.data.Zakaznik_pristroje_options) {
            return [];
        }
        if (!props.data.Zakaznik){
            options = Object.values(props.data.Zakaznik_pristroje_options).flatMap(options => options);
        } else{
            options = props.data.Zakaznik_pristroje_options[props.data.Zakaznik]
        }
        let selected_instruments = props.data.Pristroje.map(item => (
            {"SNR": item.Pristroj.SNR, "Typ": item.Pristroj["Produkt"].Typ, "CP_verzia": item["CP_verzia"]}
        ))
        if (!options) {
            return []
        }
        options = options.filter(option =>
            !selected_instruments.some(instrument =>
                instrument.SNR === option.SNR && instrument.Typ === option["Produkt"].Typ && instrument.CP_verzia === props.cpVersion)
        );
        return options
    }

    function handleSelection(event) {
        props.selectInstrument(event, props.instrumentIndex)
    }

    function renderMenuItemChildren(option, props) {
        return (
            <div>
                {`${option.SNR} - ${option.Produkt ? option.Produkt.Typ : ""}`}
            </div>
        )
    }

    return (
        <FreeTypeSelectInput label={props.label} value={props.value} onChange={handleSelection} empty={props.empty}
                             options={getOptions()} labelKey={"SNR"} renderMenuItemChildren={renderMenuItemChildren}/>
    );
}

export default InstrumentSelector;